module.exports = __webpack_public_path__ + "img/login-img.f3520f3d.png";